import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=16039fd7&scoped=true&lang=pug"
import script from "./add-or-update.vue?vue&type=script&lang=js"
export * from "./add-or-update.vue?vue&type=script&lang=js"
import style0 from "./add-or-update.vue?vue&type=style&index=0&id=16039fd7&prod&scoped=true&lang=css"
import style1 from "./add-or-update.vue?vue&type=style&index=1&id=16039fd7&prod&lang=css"
import style2 from "./add-or-update.vue?vue&type=style&index=2&id=16039fd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16039fd7",
  null
  
)

export default component.exports